import React, { useState } from "react";
import NextModal from "./NextModal";

const TimeSelectorModal = () => {
  const [nextModal, setNextModal] = useState(false); // CREATE A FOLLOW UP PROFILE MODAL
  return (
    <>
      <div className="w-[216px] relative h-[287px] rounded-lg border-[1.393px] border-solid border-[rgba(111,_106,_248,_0.10)] bg-white shadow-[0px_8.36066px_19.5082px_0px_rgba(75,_87,_239,_0.03),_0px_-2.78689px_19.5082px_0px_rgba(75,_87,_239,_0.10);] pl-3 pr-[6px]">
        <div className="overflow-y-auto h-[280px] time-selector-modal-scroll-style">
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[20px] ">
              8:30am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[15px] ">
              11:30am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[20px] ">
              2:00am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[20px] ">
              9:30am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[20px] ">
              6:00am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
          <div className="flex items-center duration-300 pr-2 gap-2 timer-btn-hover py-2 border-b-[1.393px] border-solid border-[#F2F2F2] rounded-[20px_16px_0px_0px]">
            <button className="text-sm  time-btn text-start w-full font-normal text-black opacity-70 rounded-[2.85px] py-2 px-[20px] ">
              7:00am
            </button>
            <button
              onClick={() => setNextModal(true)}
              className="text-sm timer-next-btn hidden font-normal text-white rounded-[2.85px] bg-primary py-2 px-[30px] hover:bg-white border border-solid border-transparent hover:border-primary duration-300 hover:text-primary">
              Next
            </button>
          </div>
        </div>
        <div className=" absolute bottom-0 right-[-43%] xs:right-[-60%]   z-[9999]">
          {nextModal && <NextModal setNextModal={setNextModal} />}
        </div>
      </div>
    </>
  );
};

export default TimeSelectorModal;
